/**
 * Apple Maps place link — identification only; never persist Apple-returned content.
 * Uses the `maps://` URL scheme so clicking opens the native Maps app (on the admin's
 * computer), not a maps.apple.com browser tab.
 */
export function appleMapsPlaceUrl(applePlaceId: string): string {
  return `maps://?auid=${encodeURIComponent(applePlaceId.trim())}`;
}

/** OpenStreetMap preview link for FSQ candidate coordinates (public data). */
export function osmMapPreviewUrl(lat: number, lng: number, zoom = 16): string {
  return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;
}
